<template>
  <section class="views-forum-feed position-relative">
    <button
      class="btn btn-success position-fixed btn-modal d-lg-none d-flex align-items-center justify-content-center"
      @click="showModal = true"
    >
      <i class="icon-pencil-plus"></i>
    </button>
    <div class="container py-5">
      <div class="row">
        <div class="col-lg-3">
          <form-group
            id="filter"
            v-model="filter"
            type="text"
            placeholder="Buscar"
            :icon="icon_map[10]"
            class="d-lg-none"
          />
          <categories-forum-feed
            class="py-3 d-none d-lg-block"
            v-model="selectedCategoryId"
            @textFilter="setTextFilter"
          />
          <b-dropdown
            class="btn-categories mb-4 d-lg-none"
            toggle-class="text-decoration-none"
            menu-class="w-100 p-0"
          >
            <template #button-content>
              <div
                class="d-flex w-100 align-items-center justify-content-between px-2"
              >
                <h5 class="text-white m-0">Categorias</h5>
                <i class="icon-chevron-down"></i>
              </div>
            </template>
            <b-dropdown-item class="w-100">
              <categories-forum-feed
                v-model="selectedCategoryId"
                class="py-3"
              />
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="col-lg-6">
          <div
            class="tag-selected justify-content-center align-items-center position-relative mb-4 d-flex"
            v-if="selectedTag"
          >
            {{ selectedTag }}
            <button
              class="position-absolute close-tag-selected"
              @click="deselectedTag"
            >
              <i class="icon-x"></i>
            </button>
          </div>

          <div
            class="mb-4 row justify-content-center justify-content-lg-start"
            v-if="selectedCategoryId !== null"
          >
            <div class="col-1">
              <div class="d-flex justify-content-end">
                <button
                  class="btn-arrow-left d-flex justify-content-center align-items-center"
                  @click="selectedCategoryId = null"
                >
                  <i class="icon-arrow-left"></i>
                </button>
              </div>
            </div>
            <div class="col-10">
              <h5 class="text-uppercase">
                <i
                  :class="`${icon_map[this.selectedCategoryId]}`"
                  class="mr-2 text-success"
                ></i>
                {{ chooseCategoryTitle }}
              </h5>
              <!-- <p class="description-category">
                {{ chooseCategoryDescription }}
              </p> -->
            </div>
          </div>

          <div class="d-flex justify-content-center" v-if="isLoading">
            <b-spinner
              variant="success"
              style="width: 2rem; height: 2rem; margin-bottom: 2rem;"
            />
          </div>
          <div
            class="d-flex justify-content-center"
            v-if="!isLoading && !topics.length"
          >
            <p class="text-secondary">
              Não há tópicos a serem exibidos
            </p>
          </div>
          <div v-if="!isLoading">
            <topics-forum
              v-for="topic in topics"
              :key="topic.id"
              :topic="topic"
              @refresh="dispatch(true)"
            />
            <div>
              <pagination-see-more
                @dispatch="setLimitPosts"
                :isLoading="loadingNewTopics"
                :count="count"
                :addedValue="3"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-none d-lg-block">
          <new-topic @showModal="showModal = true" @select-tag="onSelectTag" />
        </div>
      </div>
      <b-modal
        id="modal-new-topic"
        v-model="showModal"
        size="lg"
        centered
        hide-footer
        hide-header
      >
        <modal-new-topic
          :options="categories"
          @close-modal="showModal = false"
          @refresh="dispatch(true)"
        />
      </b-modal>
    </div>
  </section>
</template>

<script>
import CategoriesForumFeed from "@/components/forumFeed/CategoriesForumFeed.vue";
import TopicsForum from "@/components/forumFeed/TopicsForum.vue";
import NewTopic from "@/components/forumFeed/NewTopic.vue";
import { mapState } from "vuex";
import { formFields } from "@/functions/helpers.js";
import ModalNewTopic from "../components/forumFeed/ModalNewTopic.vue";

export default {
  components: {
    CategoriesForumFeed,
    TopicsForum,
    NewTopic,
    ModalNewTopic
  },
  data() {
    return {
      selectedTag: null,
      selectedCategoryId: null,
      filter: "",
      ...formFields([
        "topicSelected",
        "topicTag",
        "topicContent",
        "topicTitle"
      ]),
      showModal: false,
      isLoading: false,
      showTopic: true,
      limit: 3,
      showBtnSeeMore: true,
      loadingNewTopics: false
    };
  },
  watch: {
    selectedCategoryId() {
      this.dispatch();
    },
    filter(newVal) {
      this.$store.dispatch("forum/filterTopicsByText", { text: newVal });
    }
  },
  methods: {
    onSelectTag(tag) {
      this.selectedTag = tag;
      this.isLoading = true;
      this.$store
        .dispatch("forum/filterByTags", tag)
        .then()
        .finally(() => {
          this.isLoading = false;
          this.selectedCategoryId = null;
        });
    },
    dispatch(refreshing = null, limit, loading) {
      if (limit) this.limit = limit;
      if (!this.selectedCategoryId && !this.selectedTag) {
        if (!refreshing) this.isLoading = true;
        if (loading) this.loadingNewTopics = loading;
        this.$store
          .dispatch("forum/getTopics", this.limit)
          .then()
          .finally(() => {
            this.isLoading = false;
            if (loading) this.loadingNewTopics = false;
          });
      } else if (this.selectedCategoryId) {
        this.selectedTag = "";
        if (!refreshing) this.isLoading = true;
        if (loading) this.loadingNewTopics = true;
        this.$store
          .dispatch("forum/filterByCategories", {
            id: this.selectedCategoryId,
            limit: this.limit
          })
          .then()
          .finally(() => {
            if (!refreshing) this.isLoading = false;
            if (loading) this.loadingNewTopics = false;
          });
      }
    },
    deselectedTag() {
      this.selectedTag = null;
      this.dispatch();
    },
    setLimitPosts(payload) {
      this.dispatch(true, payload.limit, payload.loading);
    },
    setTextFilter(payload) {
      this.filter = payload.textFilter;
    }
  },
  computed: {
    ...mapState("forum", ["categories", "topics", "count"]),
    chooseCategoryTitle() {
      const category = this.categories.find(
        c => c.id == this.selectedCategoryId
      );
      return category?.title || "";
    },
    chooseCategoryDescription() {
      const category = this.categories.find(
        c => c.id == this.selectedCategoryId
      );
      return category?.description || "";
    },
    icon_map() {
      return {
        1: "icon-file-music",
        2: "icon-mic",
        3: "icon-amplifier",
        4: "icon-violin",
        5: "icon-piano-keys-light",
        6: "icon-guitar-electric",
        7: "icon-guitar",
        8: "icon-guitar-acoustic",
        9: "icon-drums",
        10: "icon-search"
      };
    }
  },
  mounted() {
    this.isLoading = true;
    this.$store
      .dispatch("forum/getTopics", this.limit)
      .then()
      .finally(() => {
        this.isLoading = false;
      });
  }
};
</script>

<style lang="scss">
.views-forum-feed {
  .container {
    max-width: 1600px;
  }

  .tag-selected {
    background-color: #111112;
    height: 57px;
    border-radius: 8px;
  }

  .close-tag-selected {
    right: 10px;
    background: transparent;
    border: none;
    color: #fff;
    transition: 0.4s;
    &:hover {
      transform: scale(1.3);
    }
  }

  .description-category {
    font-size: 14px;
  }

  .icon-file-music {
    color: #2db563;
  }

  .btn-arrow-left {
    border-radius: 50%;
    border: 1px solid #8b8b8b;
    background: transparent;
    height: 25px;
    width: 25px;

    &:hover {
      transform: scale(0.9);
    }
  }

  .icon-arrow-left {
    color: #8b8b8b;
  }

  .btn-categories {
    width: 100%;
  }

  .btn-secondary {
    background: #111112;
    border: none;
  }

  .dropdown-item {
    padding: 0;
    color: #ffffff;
  }

  .dropdown-menu {
    border-radius: 15px;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .icon {
    line-height: 37px !important;
    left: 8px !important;
    color: #767676;
  }

  .has-icon {
    .form-control {
      min-height: 0 !important;
      height: 37px !important;
      background: transparent !important;
      border: 1px solid #767676;
      border-radius: 50px;
    }
  }

  .btn-modal {
    right: 10px;
    bottom: 50px;
    z-index: 2;
    width: 65px;
    height: 65px;
    background: #2db563;
    border-radius: 50%;
  }
}

#modal-new-topic {
  .modal-header {
    background-image: none;
    align-items: center;
    justify-content: center;
    .close {
      display: none;
    }
  }
}
</style>
